import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { api } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If that email exists, we've sent a reset link.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] px-6">
      <div className="w-full max-w-md">
        <Logo size="md" />
        <h1 className="mt-12 text-4xl font-display font-semibold tracking-tight">Reset password</h1>
        <p className="mt-2 text-[#5C5F62]">Enter your account email and we&rsquo;ll send you a reset link.</p>
        {sent ? (
          <div className="mt-8 neivai-card p-6">
            <p className="text-[#1A1C1E]">Check your inbox for reset instructions.</p>
            <Link to="/login" className="mt-4 inline-block text-[#C86B53] hover:underline">Back to login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-5">
            <input
              data-testid="forgot-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-white border border-[#E5E5E5] rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#C86B53]/20 focus:border-[#C86B53] transition"
              placeholder="you@studio.com"
            />
            <button data-testid="forgot-submit-button" type="submit" disabled={busy} className="neivai-btn-primary w-full disabled:opacity-60">
              {busy ? "Sending…" : "Send reset link"}
            </button>
            <Link to="/login" className="block text-center text-sm text-[#5C5F62] hover:text-[#1A1C1E]">Back to login</Link>
          </form>
        )}
      </div>
    </div>
  );
}
